import { TableHeader } from '@common/types/common';
import { PartnershipManagementHeader } from '@company/types/partnership';

const PARTNERSHIP_MANAGEMENT_COLUMNS: TableHeader<
    Omit<PartnershipManagementHeader, 'name' | 'country'> & { company_name: string; country__name: string }
>[] = [
    { id: 'company_name', label: 'Name' },
    { id: 'services', label: 'Service', disabled: true },
    { id: 'country__name', label: 'Country' },
    { id: 'status', label: 'Status', disabled: true },
];

export { PARTNERSHIP_MANAGEMENT_COLUMNS };
